import React, { useState } from "react";
import { Link } from "react-scroll";
import { navLinks, resumeUrl } from "../../config/constants";

import {
  StyledNavbar,
  Backdrop,
  Hamburger,
  ResumeButton,
  StyledLinks,
} from "./Navbar.styles";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const ResumeLink = (
    <a
      className="resume-button"
      href={resumeUrl}
      target="_blank"
      rel="noopener noreferrer"
    >
      Resume
    </a>
  );

  return (
    <>
      <Backdrop $open={menuOpen} onClick={() => setMenuOpen(false)} />
      <StyledNavbar $open={menuOpen}>
        <Hamburger $open={menuOpen} onClick={() => setMenuOpen(!menuOpen)}>
          <span></span>
          <span></span>
          <span></span>
        </Hamburger>
        <StyledLinks $open={menuOpen}>
          <ul>
            {navLinks &&
              navLinks.map(({ url, name }, i) => (
                <li key={i}>
                  <Link
                    to={url}
                    smooth={true}
                    duration={500}
                    offset={-70}
                    onClick={() => setMenuOpen(false)}
                  >
                    {name}
                  </Link>
                </li>
              ))}
            <li>
              <ResumeButton
                href={resumeUrl}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => setMenuOpen(false)}
              >
                Resume
              </ResumeButton>
            </li>
          </ul>
          <div>{ResumeLink}</div>
        </StyledLinks>
      </StyledNavbar>
    </>
  );
};

export default Navbar;
